<template>
    <!-- INCIO WALLET -->
    
    <div class="wallet" >

        <div v-if="renderizado">

                <!-- INCIO TÍTULO PÁGINA -->
                <div class="row align-items-center wallet__tit-page tit_page">
                    <div class="col-8 col-md-8 col-lg-8">
                        <h1>Histórico</h1>
                    </div>

                    <div class="col-4 col-md-4 col-lg-4">
                        <div class="back back-hide float-right">
                            <router-link to="/investimentos/carteira-investimento" title="Voltar"><i>&nbsp;</i> voltar</router-link>
                        </div>
                    </div>

                </div>
                <!-- FINTAL TÍTULO PÁGINA -->
                <hr class="divider">

                <!-- INICIO FILTRO HISTÓRICO -->
                <WalletErenderizadoxtratoFiltro  
                    @filtrar="filtrarExtrato"
                    :detalhesOportunidade="detalhesOportunidade" 
                />
                <!-- FINAL FILTRO HISTÓRICO -->

                <div class="row">
                    <div class="col-12">
                        
                            <div class="box-border wallet__extrato">
                                <div class="wallet__extrato--tit">
                                    <h2>Minhas transações</h2>
                                </div>

                                
                                    <!-- INICIO ACCORDION -->
                                    <div class="accordion" id="accordion" :class="(loadingList) ? 'loading-accordion' : ''">
                                        <template v-if="loadingList">

                                            <div class="loader"></div>

                                        </template>
                                        <template v-else>

                                            <!-- INICIO ITEM COLLAPSE -->
                                            <WalletExtratoLista 
                                                :operacoes="Operacoes"
                                                :detalhesOportunidade="detalhesOportunidade" 
                                            />
                                            <!-- FINAL ITEM COLLAPSE -->
                                        </template>
                                    </div>
                                    <!-- FINAL ACCORDION -->

                                <!-- INICIO PAGINAÇAO -->
                                    <Pagination
                                        :paginasTotais="this.Paginas"
                                        :paginaAtual="this.PaginaAtual"
                                        :navigate="mudarPagina"
                                    />
                                <!-- FINAL PAGINAÇÃO -->



                            </div>
                    </div>
                </div>

        </div>

         <div v-else class="d-flex justify-content-center align-items-center dashboard">
            <div class="dashboard__complete">
                <div class="row">
                    <div class="col-12 text-center">
                   
                        <h1>Histórico - Carteira Virtual</h1>
                        <div class="loading-animation"></div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import WalletService from '../../services/api/wallet';
    import Loading from '@/components/Loading';

    import WalletExtratoLista from '../../components/Wallet/WalletExtratoLista.vue';
    import WalletExtratoFiltro from '../../components/Wallet/WalletExtratoFiltro.vue';
    import Pagination from '@/components/Pagination'
    import ApiClient from '../../utils/api-client'
    

    export default {
        data() {
          return {
            loadingList: false,
            Operacoes: null,
            Paginas: 1,
            PaginaAtual: 1,
            Filtro: {
                dataIni: '',
                dataFim: '',
            },
            showModal: false,
            operacaoDetalhes: {}
          }

        },

        components: {
            WalletExtratoLista,
            WalletExtratoFiltro,
            Pagination,
            Loading
        },

        async created() {
            const { data } = await ApiClient.getCarteiraExtrato(1);

            const { Operacoes, Paginas } = data;

            this.PaginaAtual = 1;
            this.Paginas = Paginas;
            this.Operacoes = Operacoes;
        },

        computed: {

            renderizado: function() {

                return this.Operacoes != null;
            }

        },

        methods: { 

            async filtrarExtrato(filtro) {

                const { dataIni, dataFim } = filtro;

                if(!dataIni.includes('/') || !dataFim.includes('/')) return this.Filtro = { dataIni: '', dataFim: '' }

                this.Filtro = filtro

                const { data } = await ApiClient.getCarteiraExtratoComFiltro(dataIni, dataFim, 0);

                this.PaginaAtual = 1;
                this.Operacoes = data.Operacoes;


            },

            async mudarPagina(pagina) {

                const { dataIni, dataFim } = this.Filtro;
                const temFiltro = (dataIni != '' || dataFim != '');

                // $(".collapse").collapse("hide");
                // $(".active").removeClass("active");

                this.loadingList = true;
                const { data } = (temFiltro) ? 
                    await ApiClient.getCarteiraExtratoComFiltro(dataIni, dataFim, pagina)
                    : 
                    await ApiClient.getCarteiraExtrato(pagina);
                this.loadingList = false;

                this.PaginaAtual = pagina;
                this.Operacoes = data.Operacoes;
            }
        }

    }
</script>

<style lang="scss" scoped>
@import "../../assets/styles/iouu/variables";
	@import "../../assets/styles/iouu/mixins";

    .loading-accordion {
        height: 590px;
        overflow: hidden;
    }

    .accordion {
        margin-bottom: 15px;
    }

    .loader {
        margin: auto;
        margin-top: 20px;
        border: 12px solid #f3f3f3;
        border-top-color: #41d3bd ;
        border-radius: 50%;
        width: 90px;
        height: 90px;
        animation: spin 500ms linear infinite;
        position: relative;
        top: 295px;
        margin-top: -45px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    #search {
      border-radius: 5px;
    }

    .wallet__filter--date i.ico-calendar {
      bottom: 16.5px;
    }

    .tfooter {
      border-bottom: none;
      font-weight: 700;
    }

    table {
      &.right{
        margin-bottom: 1rem !important;
      }
    }

    .nBorder {
      border-bottom: none;
    }

</style>



// WEBPACK FOOTER //
// src/views/Wallet/WalletHistorico.vue